"use strict";

var _interopRequireWildcard = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
var Quill = _interopRequireWildcard(require("quill"));
var _applicationStore = require("../../api/applicationStore.js");
var _applicationState = require("../../api/applicationState.js");
var _uploads = require("../../api/uploads.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isDisable: false,
      appNameData: [],
      appNameDatas: [],
      formLabelWidth: "100px",
      isRepeat: false,
      data: {
        name: "",
        version: "",
        cnFixPoint: "",
        enFixPoint: "",
        hkFixPoint: "",
        jpFixPoint: ""
      },
      rulesadd: {
        name: [{
          required: true,
          trigger: "change"
        }],
        version: [{
          required: true,
          trigger: "change"
        }]
      },
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], ["blockquote", "code-block"], [{
            header: 1
          }, {
            header: 2
          }], [{
            list: "ordered"
          }, {
            list: "bullet"
          }], [{
            script: "sub"
          }, {
            script: "super"
          }], [{
            indent: "-1"
          }, {
            indent: "+1"
          }], [{
            direction: "rtl"
          }], [{
            size: ["small", false, "large", "huge"]
          }], [{
            header: [1, 2, 3, 4, 5, 6, false]
          }], [{
            color: []
          }, {
            background: []
          }], [{
            font: []
          }], [{
            align: []
          }], ["image"]]
        },
        theme: "snow",
        placeholder: "请输入文本信息..."
      },
      addRange: [],
      Rangeflag: false
    };
  },
  mounted: function mounted() {
    this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", this.imgHandler);
  },
  methods: {
    getFirst: function getFirst() {
      var _this = this;
      (0, _applicationStore.searchStatus)().then(function (res) {
        _this.data.name = "";
        _this.data.version = "";
        _this.appNameData = res.voList;
      });
    },
    getSecond: function getSecond() {
      var _this2 = this;
      (0, _applicationStore.searchVersions)({
        name: this.data.name
      }).then(function (res) {
        _this2.appNameDatas = res.voList;
      });
    },
    handleChangeFirst: function handleChangeFirst(value) {
      this.data.name = value;
      this.data.version = "";
    },
    imgHandler: function imgHandler(state) {
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (this.addRange != "" && this.addRange != null) {
        this.Rangeflag = true;
      }
      if (state) {
        var fileInput = document.getElementById("imgInput");
        fileInput.click();
      }
    },
    to_upload_img: function to_upload_img(formdata) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var fd = new FormData();
        fd.append("file", formdata.file);
        (0, _uploads.uploads)(fd).then(function (res) {
          if (_this3.Rangeflag) {
            _this3.addRange = _this3.$refs.myQuillEditor.quill.getSelection();
            _this3.$refs.myQuillEditor.quill.insertEmbed(_this3.addRange !== null ? _this3.addRange.index : 0, "image", res.voT.downloadUrl, Quill.sources.USER);
            _this3.Rangeflag = false;
          }
        });
      });
    },
    submit: function submit() {
      var _this4 = this;
      this.$refs.data.validate(function (valid) {
        if (valid) {
          _this4.isRepeat = true;
          _this4.isDisable = true;
          (0, _applicationState.addList)(_this4.data).then(function (res) {
            if (res.success) {
              _this4.$message({
                type: "success",
                message: "添加成功",
                center: true
              });
              _this4.$store.dispatch("tagsView/delView", _this4.$route).then(function () {
                return _this4.$store.dispatch("tagsView/delCachedView", {
                  name: "ApplicationState"
                });
              }).then(function () {
                _this4.$nextTick(function () {
                  _this4.$router.replace({
                    path: "/firmware/applicationState"
                  });
                });
              });
            } else {
              _this4.$message({
                type: "warning",
                message: res.errorMsg,
                center: true
              });
              _this4.isRepeat = false;
              _this4.isDisable = false;
            }
          });
        } else {
          _this4.$message({
            type: "warning",
            message: "请填写完整",
            center: true
          });
        }
      });
    }
  }
};